// extracted by mini-css-extract-plugin
export default {"cls1":"BulkFollowListModal-cls1__OE","cls2":"BulkFollowListModal-cls2__8I BulkFollowListModal-cls1__OE"};